import React from 'react'
import * as h from '../../helpers/helpers';
import { H1, H2, TX_B, TXC, TXC_B, TXR_B, TXR_I, TXR_II } from "../../styles/urar-styles";

export function CONTACTS() {
	var client = global.ptr.parties.GetPartyOfRole("Client");
	var lender = global.ptr.parties.GetPartyOfRole("Lender");
	if (lender && lender.PartyIsRole("Client")) lender = null;
	var amc = global.ptr.parties.GetPartyOfRole("ManagementCompany");
	if (amc && amc.PartyIsRole("Client")) amc = null;
	var appraisers = global.ptr.parties.GetPartiesOfRole("Appraiser");
	var supervisor = global.ptr.parties.GetPartyOfRole("AppraiserSupervisor");
	var assistors = global.ptr.parties.GetPartiesOfRole("SignificantRealPropertyAppraisalAssistance");
	//console.log("parties: ", appraisers, supervisor);
	if (appraisers.length === 0) appraisers.push(supervisor);

	return (
		<div>
			<CONTACT party={client} />
			<CONTACT party={lender} />
			<CONTACT party={amc} />
			{ appraisers &&
				appraisers.map((a, i) => {
					return (<CONTACT key={i} party={a} />)
				})
			}
			{ supervisor &&
				<CONTACT party={supervisor} />
			}
			{ assistors &&
				assistors.map((a, i) => {
					var descr = "";
					var r = a.GetRole("SignificantRealPropertyAppraisalAssistance");
					if (r) descr = r.GetDescription();
					return (
						<React.Fragment key={i}>
							<CONTACT party={a} />
							<TXC_B title="Description" value={descr} />
						</React.Fragment>
					)
				})
			}
		</div>
	)
}

function CONTACT({party}) {
	//console.log("contact: ", party);
	if (!party) return;
	var title = party.GetRoleTypes();
	return (
		<div>
			<H2 title={title} />
			<div className='col2 mt-3'>
				<div>
					<NAME party={party}/>
				</div>
				<div>
					<CREDENTIALS party={party} />
				</div>
			</div>
		</div>
	)
}

function NAME({party}) {
	var pName = party.GetIndividualName();
	var pDesig = party.GetDesignation();
	var pCompany = party.GetCompanyName();
	if (pName && pName === pCompany) pName = undefined;

	var adr = [];
	if (party.address) {
		adr.push(party.address.GetFullStreetAddress());
		adr.push(party.address.GetCSZ());
	}

	return (
			<div>
				<TXR_I title="Name" value={pName} />
				<TXR_I title="Designation" value={pDesig} />
				<TXR_I title="Company Name" value={pCompany} />
				<TXR_I title="Company Address" value={adr} />
				<SCOPE party={party} />
			</div>
	)
}

function CREDENTIALS({party}) {

	var license = party.GetLicense();
	//console.log("license: ", party, license);
	if (!license) return undefined;
	var type = h.toEnumText(license.appraiserLicense?.appraiserLicenseType);
	var appraiser = party.GetAppraiser();
	//console.log("type: ", type);
	
	return (
			<div>
				<TX_B title="Credentials" />
				<TXR_I title="Level" value={type} />
				{ type !== "None" &&
				<>
					<TXR_I title="ID" value={license.licenseDetail.licenseIdentifier} />
					<TXR_I title="State" value={license.licenseDetail.licenseIssuingAuthorityStateCode} />
					<TXR_I title="Expires" value={license.licenseDetail.licenseExpirationDate.FormatMDY()} />
					<APPRAISER_INFO appraiser={appraiser} />
				</>
				}
			</div>
	)
}

function SCOPE({party}) {
	if (!party) return undefined;
	let attrib = '';
	if (party.PartyIsRole('Appraiser')) {
			attrib = 'Appraiser';
	} else if (party.PartyIsRole('AppraiserSupervisor')) {
			attrib = 'AppraiserSupervisor';
	} else if (party.PartyIsRole('SignificantRealPropertyAppraisalAssistance')) {
			attrib = 'SignificantRealPropertyAppraisalAssistance';
	}

	//console.log("scope: ", party, attrib);

	if (attrib) {
    var role = party.GetRole(attrib);
		var label = role.label;

		//console.log(attrib, label, role);
    if (label) {
			var rels = global.ptr.relationships.GetRelationshipsTo('INSPECTION_CompletedBy_ROLE', label);
			//console.log("rels: ", rels);
			if (rels && rels.length > 0) {
				var roleName = party.GetRoleTypes();
				var inspection = global.ptr.subProp.GetInspection(rels[0]);
				//console.log("inspection: ", inspection);
				if (inspection) {
					var date = inspection.inspectionDetail.inspectionDate.FormatMDY();
					//if (!date || !date.hasFullDate()) date = undefined;
					var ext = h.toEnumText(inspection.inspectionDetail.propertyExteriorInspectionMethodType);
					var int = h.toEnumText(inspection.inspectionDetail.propertyInteriorInspectionMethodType);
					return (
						<div>
							<TX_B title={`Scope of Inspection by ${h.toEnumText(roleName)}`} />
							<TXR_I title='Subject Property Inspection' value=' ' />

							<TXR_II title="Exterior" value={ext} />
							<TXR_II title="Interior" value={int} />
							<TXR_II title="Inspection Date" value={date} />
						</div>
					);
				}
			}
		}	
	}
}

function APPRAISER_INFO({appraiser}) {
	//console.log("appraiser: ", appraiser);
	if (!appraiser) return undefined;

	return (
		<div>
			<TXR_B title="ASC Identifier" value={null} />
			<TXR_B title="VA Appraier ID" value={null} />
			<TXR_B title="FHA Appraiser" value={null} />
			<TXR_B title="Employment Type" value={null} />
		</div>
	)
}

export function PROPERTY_DATA_REPORT() {
	var pdr = global.ptr.valDetail.propertyDataReportIndicator ?? false;
	if (!pdr) return undefined;
	var inspSvc = global.ptr.inspectionService;
	//console.log("inspSvc: ", inspSvc);
	var inspResp = inspSvc.inspectionServiceResponse;
	//console.log("inspResp: ", inspResp);
	var inspDetail = inspResp.inspectionDetail;
	//console.log("inspDetail: ", inspDetail);
	var dataCollector = global.ptr.inspection.parties.GetPartyOfRole("PropertyDataCollector");
	var partyRole = dataCollector.GetRole("PropertyDataCollector");
	var commentary = global.ptr.valRpt.GetValuationCommentaryText("Assignment");
	//console.log("cmt: ", commentary);

	return (
		<div>
			<H2 title="Property Data Report" />

			<TXR_I title="Name" value={dataCollector.GetName()} />
			<TXR_I title="Occupation" value={partyRole.GetOccupation()} />
			<TXR_I title="Company Name" value={dataCollector.GetFullName()} />
			<TXR_I title="Company Address" value={dataCollector.address.GetFullStreetAddress()} />
			<TXR_I title="" value={dataCollector.address.GetCSZ()} />
			<TXR_I title="Reference ID" value={global.ptr.appraisalDocument.GetInspectorFileIdentifier()} />

			<TXR_I title="Subject Property Inspection" value=" " />
			<TXR_II title="Exterior" value={inspDetail.propertyExteriorInspectionMethodType} />
			<TXR_II title="Interior" value={inspDetail.propertyInteriorInspectionMethodType} />
			<TXR_II title="Inspection Date" value={inspDetail.inspectionDate.FormatMDY()} />
		</div>
	)

}